import React from 'react'
import {Flex} from '/app/src/component'
import MenuSubTitle from '/app/src/component/Menu/SubTitle';
import MenuSubItem  from '/app/src/component/Menu/SubItem';

export default class MyProfile extends React.Component {
    render(){
        return (
            <Flex column h='100%' w='100%'>
                <MenuSubTitle
                    svgSrc='/images/Menu_Profile.svg'
                    text='Min Profil'
                    onClick={this.props.onClick}
                    svgfill='#76b376'/>
                <Flex column overflowY='auto'>
                <MenuSubItem
                    svgSrc='/images/Menu_ProfileProfile_L.svg'
                    text='Profilinställningar' to='/user/profilepicture'
                    svgfill='#76b376'/>
                <MenuSubItem
                    svgSrc='/images/Menu_ProfilePassword.svg'
                    text='Byt Lösenord' to='/user/changepassword'
                    svgfill='#76b376'/>
                <MenuSubItem
                    svgSrc='/images/Menu_ProfileNotifications.svg'
                    text='Ljud och aviseringar' to='/user/notifications'
                    svgfill='#76b376'/>
                </Flex>
            </Flex>
        )
    }
}



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/MainMenu/MyProfile/index.js